import { AddonInputType, type BasketAddonItem } from "@/types";

/** Maps a selected add-on to `/orders` `items[].addons[]` (toggle → qty 1, number → chosen qty). */
export function serializeAddonForOrderApi(
	addonId: string,
	type: AddonInputType,
	value: BasketAddonItem["value"],
): { addonId: string; quantity: number } | null {
	if (type === AddonInputType.toggle) {
		if (value !== true) return null;
		return { addonId, quantity: 1 };
	}
	if (type === AddonInputType.number) {
		const q = Math.max(0, Math.floor(Number(value)));
		if (!Number.isFinite(q) || q <= 0) return null;
		return { addonId, quantity: q };
	}
	return null;
}
